import QrCode from './QrCode';

export default QrCode;
